import { QueryClient } from "@tanstack/react-query"

/**
 * Configuración predeterminada para React Query
 */
export const queryConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      gcTime: 1000 * 60 * 10, // 10 minutos
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
}

/**
 * Cliente de React Query con configuración predeterminada
 */
export const queryClient = new QueryClient(queryConfig)

/**
 * Claves de consulta para React Query
 * Centraliza todas las claves de consulta para facilitar la gestión
 */
export const queryKeys = {
  config: ["config"],
  quests: ["quests"],
  circles: ["circles"],
  upcomingQuests: ["upcomingQuests"],
  waitlists: ["waitlists"],
  journeyMission: ["journeyMission"],
  quest: (id: string) => ["quest", id],
  journey: (id: string) => ["journey", id],
  journeys: ["journeys"],
  // Añade más claves de consulta aquí a medida que añadas más endpoints
}

//TODO: compare this with the useConfig hook
